module.exports = __webpack_public_path__ + "static/proces-sprzedazy-e3f813158be08afaa59e04b00684b14d.png";